export enum PortalPartnerTypeEnum {
    /** Scenario author — writes stories, earns % of sales of produced games. */
    AUTHOR = 'author',
    /** Venue (hostel / hotel / cafe) — distributes QR materials, earns % of attributed sales. */
    VENUE = 'venue',
}
